import { ElMessage } from 'element-plus';
import { useUserStore } from '@/store';

export function useUpgradeModal() {
  const userStore = useUserStore();

  function open(options?: { type?: string }) {
    if (!window.LifangUpgradeModal) {
      ElMessage.warning('弹窗暂未加载，请刷新页面后重试');
      return;
    }

    new window.LifangUpgradeModal().show({
      userData: userStore.userData,
      ...options
    });
  }

  /** 打开会员升级弹窗 */
  function showUpgrade() {
    open();
  }

  /** 打开云币购买弹窗 */
  function showCoinBuy() {
    open({ type: 'coin' });
  }

  return { showUpgrade, showCoinBuy };
}
